import React, {useState} from "react";
import APIAdapter from "../APIClient/APIAdapter";
import Constants from "../Constants/Constants";
import LocalStore from "../Storage/LocalStore";
import { AuthContext } from '../App';
import Validator from "../Constants/Validator";

export const LoginContext = React.createContext();


export const LoginContextProvider = (props) => {

  const [state, dispatch] = React.useReducer(
    (prevState, action) => {
      switch (action.type) {
        case 'TOGGLE_LOADER':
          return {
            ...prevState,
            isLoading: action.isLoading
          };
          case 'TOGGLE_ERROR':
          return {
            ...prevState,
            errorMessage: action.errorMessage
          };
      }
    },
    {
        isLoading: false,
        errorMessage: ''
    }
  );


  const { signIn } = React.useContext(AuthContext);

  const doLogin = (async (request) => {

    if (!Validator.isNullOrEmptyValue(request.email)) {
        dispatch({ type: 'TOGGLE_ERROR', errorMessage: 'Please enter email address' });
        return;
    }
    else if (!Validator.isValidEmail(request.email)) {
        dispatch({ type: 'TOGGLE_ERROR', errorMessage: 'Please enter valid email address' });
        return;
    }
    else if (!Validator.isNullOrEmptyValue(request.password)) {
        dispatch({ type: 'TOGGLE_ERROR', errorMessage: 'Please enter password' });
        return;
    }

      const params = {
          "userName": request.email,
          "password": request.password,
          "deviceType": "web",
          "deviceToken": "xxxxx"
      }
      
    dispatch({ type: 'TOGGLE_LOADER', isLoading: true });
      var response = await APIAdapter.POST(Constants.kAPILogin, params);
      dispatch({ type: 'TOGGLE_LOADER', isLoading: false });
      // console.log(response);
      if(response.success) {
        LocalStore.SaveData("UserData", JSON.stringify(response.data));
        APIAdapter.authToken = response.data.token
        APIAdapter.refToken = response.data.refToken
        signIn(true);
      }
      else {
        dispatch({ type: 'TOGGLE_ERROR', errorMessage: response.message });
      }

  })

  return (
    
    <LoginContext.Provider value={{ ...state, doLogin }}>
      {props.children}
    </LoginContext.Provider>
  );

};